import { CartItem } from '../types';
import { getColorName } from '../constants';
import { API_BASE } from './api';

export const createStripeCheckoutSession = async (
  cart: CartItem[],
  customerEmail: string,
  customer: {
    firstName: string;
    lastName: string;
    address: string;
    city: string;
    zip: string;
    country?: string;
  }
) => {
  // Solo enviamos lo mínimo: el backend pone el precio desde su propia lista.
  // Nunca se envían precios desde el navegador.
  const slimCart = cart.map(item => ({
    id: item.product.id,
    quantity: item.quantity,
    size: item.size,
    color: getColorName(item.color),
    customImageUrl: item.customImageUrl || null,
  }));

  try {
    const response = await fetch(`${API_BASE}/api/create-checkout-session`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        cart: slimCart,
        email: customerEmail,
        customer
      }),
    });

    if (!response.ok) {
      const text = await response.text();
      console.error("Error backend:", text);
      throw new Error("Error creando sesión de Stripe");
    }

    const data = await response.json();
    return data; // { url: "https://checkout.stripe.com/..." }
  } catch (err) {
    console.error("Error fetch:", err);
    throw err;
  }
};
